import React, { useContext } from 'react'
import styles from './CuisineGenre.module.css'
import { adaptCuisineData } from './cuisineAdapter'
import { FormTitle } from '../../../Common/FormTitle'
import { CategorySelector } from '../../../Common/Pulldown/CategorySelector'
import { useAbTestGtm } from '../../../../hooks/useAbTestGtm'
import { StepContext } from '../../StepContainer'

// 業界未経験は料理ジャンル・仕事内容とも「その他」にする。
// constants/progressBanner の選択肢と同じIDであることはテストで確認している
export const INEXPERIENCED_GENRE = { id: 31, name: 'その他(料理ジャンル)' }
export const INEXPERIENCED_OCCUPATION = { id: 30, name: 'その他(仕事内容)' }
// 仕事内容ステップ（JobSeekerSteps の index）。未経験導線ではここを回答済みにして飛ばす
const JOB_CONTENT_STEP_INDEX = 8
const JOB_CONTENT_STEP_KEY = `step${JOB_CONTENT_STEP_INDEX}` as const

export const CuisineGenre = () => {
    const { dataClickLabel, dataViewLabel } = useAbTestGtm()
    const cuisineData = adaptCuisineData()

    const {
        handleNext,
        updateUserResume,
        setDisplayValue,
        setStepStatus,
        setSkippedSteps,
        skippedSteps,
        registerToken,
    } = useContext(StepContext)

    // このステップは /signup とも共有している。未経験導線は JobSeekerSteps の
    // ステップ構成（JOB_CONTENT_STEP_INDEX）が前提のため、registerToken の有無で
    // PF転換フォームかどうかを判定する（StepContainer のステップ一覧の分岐と同じ基準）
    const isJobSeekerEdit = !!registerToken

    const handleInexperienced = () => {
        updateUserResume(0, 'genreId', INEXPERIENCED_GENRE.id)
        updateUserResume(0, 'occupationIds', INEXPERIENCED_OCCUPATION.id)
        setDisplayValue('genre', INEXPERIENCED_GENRE.name)
        setDisplayValue('occupation', INEXPERIENCED_OCCUPATION.name)
        setStepStatus(JOB_CONTENT_STEP_KEY, true)
        setSkippedSteps([JOB_CONTENT_STEP_INDEX])
        handleNext()
    }

    // 未経験導線のあとに通常選択された場合だけ、仕事内容ステップを未回答に戻し、入れておいた「その他」も外す
    const handleGenreSelect = () => {
        if (!skippedSteps.includes(JOB_CONTENT_STEP_INDEX)) return

        updateUserResume(0, 'occupationIds', null)
        setDisplayValue('occupation', null)
        setStepStatus(JOB_CONTENT_STEP_KEY, false)
        setSkippedSteps([])
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.scrollControll}>
                <div className={styles.selectionWrapper}>
                    <div className={styles.monthbox}>
                        <FormTitle
                            formTitleText='料理ジャンルはなんですか？'
                            dataViewLabel={dataViewLabel('EF_StepForm_料理ジャンル')}
                            dataClickLabel={dataClickLabel('EF_StepForm_料理ジャンル-戻る')}
                        />
                    </div>
                    <CategorySelector
                        categoryData={cuisineData}
                        formKey={['userResumesAttributes', 'genreId']}
                        displayFormKey={'genre'}
                        idField='genreId'
                        searchPlaceholder='料理ジャンルを検索する'
                        clickLabelPrefix='EF_StepForm_料理ジャンル'
                        formatClickLabel={dataClickLabel}
                        onSelect={
                            isJobSeekerEdit ? handleGenreSelect : undefined
                        }
                        searchNotice={
                            isJobSeekerEdit ? (
                                <p className={styles.inexperiencedText}>
                                    業界未経験の方は「
                                    <button
                                        type='button'
                                        className={styles.inexperiencedLink}
                                        onClick={handleInexperienced}
                                        data-click-label={dataClickLabel('EF_StepForm_料理ジャンル-未経験')}
                                    >
                                        こちら
                                    </button>
                                    」からお進みください
                                </p>
                            ) : undefined
                        }
                    />
                </div>
            </div>
        </div>
    )
}
